import { isLoadedInDeveloperMode } from './isLoadedInDeveloperMode.js';

const webextensions = {
    isLoadedInDeveloperMode
};

export { webextensions };
